import { render, staticRenderFns } from "./score1-explain-popup.vue?vue&type=template&id=4e8d6d39&scoped=true&"
import script from "./score1-explain-popup.vue?vue&type=script&lang=js&"
export * from "./score1-explain-popup.vue?vue&type=script&lang=js&"
import style0 from "./score1-explain-popup.vue?vue&type=style&index=0&id=4e8d6d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d6d39",
  null
  
)

export default component.exports